import Vue from 'vue'
import {
  Dropdown,
  DropdownMenu,
  Loading,
  Message,
  MessageBox,
  DropdownItem,
  Notification,
  Carousel,
  CarouselItem
} from 'element-ui'

Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Loading.directive)
Vue.prototype.$ELEMENT = { size: 'small' }
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification
